import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const PERSON = {
  id: 'admin.khuyana.person',
  title: 'Administración de Personas',

  labels: {
    ...COMMONS,
    age: 'Edad',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    lastName: 'Apellido',
    born: 'Nacimiento',
    locationBornPlaceholder: 'Lugar de nacimiento...',
    additional: 'Género / Estado civil',
    contact: 'Contacto',
    emailPlaceholder: 'Correo electrónico...',
    phonePlaceholder: '# de teléfono',
  },

  actions: {
    ...ACTIONS,
    add: `${ACTIONS.add} Persona`,
    edit: `${ACTIONS.edit} Persona`
  }
};
